"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLicenseStatusUpdateDto = instanceOfLicenseStatusUpdateDto;
exports.LicenseStatusUpdateDtoFromJSON = LicenseStatusUpdateDtoFromJSON;
exports.LicenseStatusUpdateDtoFromJSONTyped = LicenseStatusUpdateDtoFromJSONTyped;
exports.LicenseStatusUpdateDtoToJSON = LicenseStatusUpdateDtoToJSON;
exports.LicenseStatusUpdateDtoToJSONTyped = LicenseStatusUpdateDtoToJSONTyped;
const LicenseStatus_1 = require("./LicenseStatus");
const CompactStatus_1 = require("./CompactStatus");
/**
 * Check if a given object implements the LicenseStatusUpdateDto interface.
 */
function instanceOfLicenseStatusUpdateDto(value) {
    return true;
}
function LicenseStatusUpdateDtoFromJSON(json) {
    return LicenseStatusUpdateDtoFromJSONTyped(json, false);
}
function LicenseStatusUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ncsbnId': json['ncsbnId'] == null ? undefined : json['ncsbnId'],
        'status': json['status'] == null ? undefined : (0, LicenseStatus_1.LicenseStatusFromJSON)(json['status']),
        'statusMessage': json['statusMessage'] == null ? undefined : json['statusMessage'],
        'compactStatus': json['compactStatus'] == null ? undefined : (0, CompactStatus_1.CompactStatusFromJSON)(json['compactStatus']),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
    };
}
function LicenseStatusUpdateDtoToJSON(json) {
    return LicenseStatusUpdateDtoToJSONTyped(json, false);
}
function LicenseStatusUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ncsbnId': value['ncsbnId'],
        'status': (0, LicenseStatus_1.LicenseStatusToJSON)(value['status']),
        'statusMessage': value['statusMessage'],
        'compactStatus': (0, CompactStatus_1.CompactStatusToJSON)(value['compactStatus']),
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString().substring(0, 10)),
    };
}
//# sourceMappingURL=LicenseStatusUpdateDto.js.map